/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import FormInput from "./FormInput";
import Globals from "../shared/Globals";
import FormLabel from "./FormLabel";
import LoadingAlert from "./LoadingAlert";
import { SidebarGlobal } from "./_Sidebar";
import Alert from "./Alert";
import Icon from "./Icon";
import AppActions from "./AppActions";
import { v4 as uuidv4 } from 'uuid';

class ScheduleView extends BaseCom {
    constructor(props) {
        super(props);

        var now = new Date();

        try {
            if (now.getUTCMinutes() > 30) {
                now.setUTCHours(now.getUTCHours() + 1);
                now.setUTCMinutes(0);
            }
            else {
                now.setUTCMinutes(30);
            }
        }
        catch { }

        this.state = {
            item: {
                patient: {},
                treatment: {},
                visitType: {},
                selectedVisitTypes: {},
                scheduleDate: Globals.toISODateString(now),
                batchVisits: []
            },
            treatmentList: [],
            patientSelect: props.patientSelect,
            typeList: [],
            userList: [],
            posList: [
                { id: '02', name: '02 - Telehealth (OOH)' },
                { id: '10', name: '10 - Telehealth (In Home)' },
                { id: '11', name: '11 - Office' },
                { id: '12', name: '12 - Patient Home' },
                { id: '13', name: '13 - Assisted Living Facility' },
                { id: '15', name: '15 - Group Home' },
                { id: '22', name: '22 - Hospital' },
                { id: '24', name: '24 - ASC' },
                { id: '31', name: '31 - SNF' },
                { id: '32', name: '32 - Nursing Homes' }
            ]
        };
        this.pullTreatmentList = this.pullTreatmentList.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.setPatientByID = this.setPatientByID.bind(this);
    }

    componentDidMount() {
        if (this.state.patientSelect)
            this.setPatientByID(this.props.params.patientID);

        qreq.get('/api/visit/type/list?isEncounter=' + (this.props.event ? 'false' : 'true'), j => {
            if (j.list) {
                this.setState({ typeList: j.list, placementType: j.list.find(a => a.name === 'Placement') });
            }
        });

        qreq.get('/api/user/list?showDisabled=false', j => {
            if (j.list)
                this.setState({ userList: j.list });
        });

        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-primary" onClick={() => document.getElementById('c-submit').click()}> <FontAwesomeIcon icon={fa.faSave} /> <L>Schedule</L></button></>);
        this.addBatch();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.patientSelect !== this.props.patientSelect) {
            this.setState({ patientSelect: this.props.patientSelect });
            if (this.props.patientSelect)
                this.setPatientByID(this.props.params.patientID);
        }
    }

    pullTreatmentList(obj) {
        this.setState({ isLead: false });
        if (!obj)
            this.setState({ treatmentList: [] });
        else {
            this.setState({ isLead: obj.isLead });
            qreq.post('/api/patient/treatment/list', { parentObjectID: obj.id }, j => {
                if (j.list)
                    this.setState({ treatmentList: j.list });
                else if (j.errorCode !== 0)
                    this.alert(j.errorMessage);
            });
        }
    }

    onChange(v) {
        var batchVisits = [...this.state.item.batchVisits];
        for (let n = 0; n < batchVisits.length; n++) {
            batchVisits[n] = { ...batchVisits[n] };
        }
        this.setState({ item: { ...this.state.item, batchVisits: batchVisits } });
    }


    setPatientByID(id) {
        this.setState({ patientLoading: true });
        qreq.get('/api/patient/get/' + id, j => {
            if (j.item) {
                this.state.item.patient = j.item;
                this.setState({ item: this.state.item, patientLoading: false });
                this.pullTreatmentList(j.item);
            }
        });
    }

    addBatch = () => {
        let item = { ...this.state.item };
        item.batchVisits.push({
            key: uuidv4(),
            visitType: {},
            selectedVisitTypes: {},
            scheduleDate: Globals.toISODateString(new Date()),
        });
        this.setState({ item: item });
    }

    removeBatch = (item) => {
        let list = [...this.state.item.batchVisits];
        var find = list.find(a => a.key === item.key);
        if (find) {
            list.splice(list.indexOf(find), 1);
            this.setState({ item: { ...this.state.item, batchVisits: list } });
        }
    }

    toggleSelectedVisitType = (batch, type) => {
        let item = { ...this.state.item };
        let batchVisits = [...item.batchVisits];
        let b = batchVisits.find(b => b === batch);
        if (!b.selectedVisitTypes)
            b.selectedVisitTypes = {};
        b.selectedVisitTypes[type.id] = !b.selectedVisitTypes[type.id];
        this.setState({ item: { ...item, batchVisits: batchVisits } });
    }

    onSubmit(e) {
        e.preventDefault();
        var item = { ...this.state.item };
        if (this.props.event)
            item.isEncounter = false;
        else {
            item.isEncounter = true;
            item.treatment.patientID = item.patient.id;
        }
        item.selectedVisitTypesJsonData = JSON.stringify(item.selectedVisitTypes);
        delete item.selectedVisitTypes;
        if (!item.assignedToUserID)
            delete item.assignedToUserID;

        if (item.batchVisits) {
            item.batchVisits.forEach(b => {
                b.patient = item.patient;
                b.treatment = item.treatment;
                b.selectedVisitTypesJsonData = JSON.stringify(b.selectedVisitTypes);
                delete b.selectedVisitTypes;
            });
        }

        this.setState({ saving: true });
        qreq.post('/api/visit/save', item, j => {
            if (j.errorCode === 0) {
                if (item.batchVisits) {
                    this.success('Encounter(s) scheduled successfully.');
                    this.props.navigate('/calendar');
                }
                else {
                    this.success('Encounter scheduled successfully.');
                    this.props.navigate('/visit/view/' + j.item.id);
                }
            }
            else
                this.alert(j.errorMessage);
            this.setState({ saving: false });
        }, () => {
            this.setState({ saving: false });
            this.unkownErrorCallback();
        });
    }


    render() {
        return <div className="container-fluid">
            <h1><L>Scheduler</L></h1>
            <form onSubmit={this.onSubmit}>
                {this.props.event ? <Card title="Schedule Event">
                    <FormInput model={this.state.item} name="eventName" label="Event Name" type="text" />
                    <FormInput model={this.state.item} name="scheduleDate" label="Encounter Schedule Date" type="date" dateAllowTime={true} required />
                    <FormInput model={this.state.item} name="description" label="Details" type="textarea" rows={8} />
                    <div className="mb-3">
                        <label className="form-label"><L>Event Type</L></label>
                        {this.state.typeList.map(i => <div key={i.id}>
                            <FormInput model={this.state.item.selectedVisitTypes} name={i.id} type="switch" label={i.name} onChange={this.onChange} />
                        </div>)}
                    </div>
                </Card> : <Card title="Schedule Encounter">
                    {this.state.patientSelect ? (this.state.patientLoading ? <LoadingAlert /> : <FormLabel model={this.state.item.patient.name} name="name" label="Patient" />) :
                        <FormInput model={this.state.item.patient} name="id" label="Patient" type="search" searchUrl="/api/patient/list?includeLeads=true&onlyActive=true" onChange={e => this.pullTreatmentList(e)} required />}
                    {this.state.isLead && <Alert type="secondary"><L>This patient is still in the queue.</L></Alert>}

                    <div className="row">
                        {this.state.item.batchVisits.map((b, idx) => <div key={idx} className="col-md-3 mb-3 position-relative">
                            {this.state.item.batchVisits.length > 1 && <button type="button" className="btn btn-danger" onClick={() => this.removeBatch(b)} style={{ position: 'absolute', right: '0' }}><FontAwesomeIcon icon={fa.faTrash} /></button>}

                            <FormInput model={b} name="scheduleDate" label="Encounter Schedule Date" type="date" dateAllowTime={true} required />


                            <FormInput model={b} name="assignedToUserID" label="Assigned To" selectDefault="Not Assigned" groupBy="roleGroupName" type="select" options={this.state.userList} />
                            {b.selectedVisitTypes && <div className="mb-3">
                                <label className="form-label"><L>Visit Type</L></label>
                                {this.state.typeList.map(i => <div key={i.id}>
                                    <div className="form-group mb-3"><div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" checked={b.selectedVisitTypes[i.id]} onChange={() => this.toggleSelectedVisitType(b, i)} />
                                        <label className="form-check-label">{i.name}</label>
                                    </div></div>
                                </div>)}
                            </div>}

                            <FormInput model={b} name="placeOfService" label="Place of Service" type="select" options={this.state.posList} required />

                        </div>)}
                        <div className="col-md mb-3">
                            <button type="button" className="btn btn-primary" onClick={this.addBatch}><FontAwesomeIcon icon={fa.faPlus} /> <L>Add Another</L></button>
                        </div>
                    </div>

                </Card>}
                <AppActions>
                    <button id="c-submit" type="submit" className="btn btn-primary btn-lg" disabled={this.state.saving}><FontAwesomeIcon icon={fa.faSave} /> <L>Schedule</L></button>
                </AppActions>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(ScheduleView);